<template>
  <div id="app">
    <el-row v-if="logged">
      <!-- Phần Menu trái -->
      <el-col :span="4" class="app-menu-left">
        <menu-left></menu-left>
      </el-col>
      <!-- Phần Nội dung phải -->
      <el-col :span="20" class="app-content-right">
        <div class="header-top">
          <header-top></header-top>
        </div>
        <div class="content-bottom">
          <router-view/>
        </div>
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col :span="24">
        <router-view/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ls from 'local-storage'
import MenuLeft from '@/components/layouts/v1/MenuLeft'
import HeaderTop from '@/components/layouts/v1/HeaderTop'
export default {
  name: 'App',
  metaInfo () {
    return {
      title: this.title,
      titleTemplate: 'Admin-NgaLinh | %s'
    }
  },
  components: {
    MenuLeft,
    HeaderTop
  },
  data () {
    return {
      title: 'Login'
    }
  },
  computed: {
    ...mapGetters('account', ['logged'])
  },
  mounted () {
    this.checkLoged()
  },
  methods: {
    ...mapActions('account', ['getAccountInfo']),
    checkLoged () {
      // if (this.$route.path !== '/login') {
      let authen = ls.get('authen')
      if (!authen) {
        this.$router.push({name: 'account-login'})
      } else {
        if (!this.logged) {
          this.getAccountInfo()
        }
      }
    }
  }
}
</script>

<style>
#app {
  color: #2c3e50;
}
.app-menu-left {
  min-height: 100vh;
}
.app-content-right {
  height: 100vh;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
}
.app-content-right .header-top {
  background-color: #fff;
  height: 50px;
  box-shadow: 0 2px 2px rgba(0,0,0,0.05), 0 1px 0 rgba(0,0,0,0.05);
}
.app-content-right .content-bottom {
  padding: 10px 15px;
  overflow-y: scroll;
  height: calc(100vh - 55px);
}
.footer-bottom {
  padding-top: 80px;
  padding-bottom: 20px;
  font-size: 12px;
}
.footer-bottom a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue